import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LiveMealFilterEntity } from '../../domain/entities/LiveMealFilterEntity'
import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'

export class LiveMealFilterModel extends LiveMealFilterEntity {
  regionIds!: Array<number>
  branchIds?: Array<number>
  userIds?: Array<string>
  trackingPanelUserId?: string
  declare statuses: Array<MealStatus>

  constructor(dataDto: LiveMealFilterEntity) {
    super()
    mapEntityProperties<LiveMealFilterModel>(this, dataDto, {
      exclude: ['regions', 'branch', 'user', 'trackingPanelUser'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id),
        branchIds: dataDto.branch ? [dataDto.branch.id] : undefined,
        userIds: dataDto.user ? [dataDto.user.id] : undefined,
        trackingPanelUserId: dataDto.trackingPanelUser?.trackingPanelUserId
      }
    })
  }
}
